import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import Button from "../../../../common/Button"
import PannelBody from "../../../../fragments/PannelBody"
import { detailsActions } from "../../../../../store/details"

import { attorneyStatusesOptions, attorneyStatusUnattached } from "../../../../../lib/systemData"
import { getColorCodeFromSystemSettings, getColorFromSystemSettings, getLabelFromSystemSettings } from "../../../../../lib/script"
import TagImproved from "../../../../fragments/TagImproved"

import classes from './CaseDetails.module.css'
import PracticesUploadItem from "../../procodocs/practicesupload/PracticesUploadItem"
import { docsFunctions } from "../../../../../lib/docs"

const CaseDetailsManagingAttorney = () => {
    const dispatch = useDispatch()
    const [managingAttorney, setManagingAttorney] = useState(null)
    const activeCase = useSelector(state => state.case.activeCase)

    const openTabHandler = () => {
        dispatch(detailsActions.setActiveTab(0))
    }

    useEffect(() => {
        if (activeCase && activeCase.attorneys && activeCase.attorneys.length > 0) {
            let managingAtty = activeCase.attorneys.find(item => item.is_managing_attorney)
            
            if (managingAtty) {
                setManagingAttorney(managingAtty)
            } else {
                setManagingAttorney(null)
            }
        } 

    }, [activeCase])

    return <>
        {managingAttorney && <PannelBody>
            <div className={classes.attorney_container}>
                <h2>{managingAttorney.law_firm.name}</h2>
                <Button btnStyle={'btn_simple'} click={openTabHandler}>
                    <i className='ti ti-external-link'></i>
                    <span className='sr-only'>go to attorney details</span>
                </Button>
            </div>
            <div className={classes.attorney_list}>
                <div className={classes.attorney_list_item}>
                    <div className={classes.attorney_name}>
                        {managingAttorney.attorney && <>{managingAttorney.attorney.first_name} {managingAttorney.attorney.last_name}</>}
                         
                        {managingAttorney.status_id && <TagImproved color={getColorFromSystemSettings(attorneyStatusesOptions(), managingAttorney.status_id)} colorCode={getColorCodeFromSystemSettings(attorneyStatusesOptions(), managingAttorney.status_id)}>{getLabelFromSystemSettings(attorneyStatusesOptions(), managingAttorney.status_id)}</TagImproved>}
                    </div>    
                    {docsFunctions.getUploadedDocumentState(activeCase?.procodocs_documents, docsFunctions.returnDocumentTypeID('LOR')?.id, 'all', managingAttorney?.id) && <div className="flex-container">
                        LOR:
                        <PracticesUploadItem practiceId={'all'} usedFor={'LOR'} uploadDisabled={true} caseAttorneyId={managingAttorney?.id} right={true} activeCase={activeCase}/>
                    </div>}
                </div>
            </div>
            
        </PannelBody>}

        {!managingAttorney && <PannelBody>
            <div className={classes.no_attorney_list_item}>
                <p>Unattached Attorney</p>
                {activeCase?.additional?.no_attorney_reason ? 
                <TagImproved color={getColorFromSystemSettings(attorneyStatusUnattached(), activeCase?.additional.no_attorney_reason)} colorCode={getColorCodeFromSystemSettings(attorneyStatusUnattached(), activeCase?.additional.no_attorney_reason)}>{getLabelFromSystemSettings(attorneyStatusUnattached(), activeCase?.additional.no_attorney_reason)}</TagImproved>
                    :
                'No reason on file'}
            </div>
            
        </PannelBody>}
    </>
}

export default CaseDetailsManagingAttorney